import * as yup from 'yup';

const identityFields = {
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces')
};

const backgroundFields = {
  backgroundImage: yup.string(),
  backgroundColor: yup.mixed()
};

const borderFields = {
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0)
};

const titleFields = {
  title: yup.string(),
  fontSize: yup.number(),
  fontWeight: yup.string(),
  fontColor: yup.mixed()
};

const buttonSuffixFields = {
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string()
};

export const bundleSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...buttonSuffixFields
});

export const promotionSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...buttonSuffixFields,
  ...titleFields,
  collectText: yup
    .string()
    .required('Free Offer Default Text is required')
    .max(25, 'Free Offer Default Text cannot exceed the maximum characters'),
  subTitleText: yup
    .string()
    .test('max-lines', 'Maximum of two lines allowed', (value) => {
      if (!value) return true;
      return (value.match(/\n/g) || []).length <= 1;
    })
});

export const progressBarSchema = yup.object().shape({
  ...identityFields,
  ...borderFields,
  backgroundOpacity: yup
    .number()
    .min(0)
    .max(100)
    .required('Background Opacity is required'),
  frameRadius: yup.number().min(0).required('Frame Radius is required'),
  barFillColor: yup.mixed(),
  barBackgroundColor: yup.mixed(),
  barRadius: yup.number().min(0),
  accumulatedItemImageUrl: yup
    .string()
    .required('Accumulated Image is required'),
  accumulatedItemBackgroundImageUrl: yup
    .string()
    .required('Accumulated Background Image is required'),
  textColor: yup.string(),
  barBackgroundImage: yup.string(),
  headerImage: yup.string()
});

export const popupSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...borderFields,
  ...titleFields,
  badgeCoverImage: yup.string()
});

export const triggeredPopupSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...titleFields,
  widgetImage: yup.string()
});

export const rewardCalendarSchema = yup.object().shape({
  ...identityFields,
  backgroundColor: yup.string(),
  dayFontColor: yup.string(),
  headerImage: yup.string(),
  collectibleBadgeImage: yup
    .string()
    .required('Collectible Badge Image is required'),
  lockedBadgeImage: yup.string().required('Locked Badge Image is required'),
  subRewardBackgroundImage: yup.string(),
  mainRewardBackgroundImage: yup.string(),
  collectIconImage: yup.string().required('Collect Icon Image is required'),
  lockedIconImage: yup.string().required('Locked Icon Image is required')
});

export const buyOneGetManySchema = yup.object().shape({
  ...identityFields,
  backgroundColor: yup.mixed(),
  backgroundImage: yup.string(),
  collectText: yup.string().required('Free Offer Text is required'),
  headerImage: yup.string(),
  offersBackgroundColor: yup.mixed(),
  freeTilesBackgroundImage: yup.string(),
  offersLockImage: yup.string().required('Lock Image is required'),
  plusImage: yup.string().required('Plus Image is required'),
  claimedIconImage: yup.string().required('Claimed Icon Image is required'),
  freeTilesLayout: yup
    .number()
    .oneOf([1, 2, 3], 'Free Tiles Layout must be 1, 2, or 3')
    .required('Free Tiles Layout is required')
});

export const rollingOfferSchema = yup.object().shape({
  ...identityFields,
  ...borderFields,
  backgroundColor: yup.mixed(),
  backgroundImage: yup.string(),
  horizontalBackgroundImage: yup.string(),
  backgroundOpacity: yup
    .number()
    .min(0)
    .max(100)
    .required('Background opacity is required'),
  borderWidth: yup
    .number()
    .min(0)
    .max(8, 'Border width cannot exceed 8px')
    .required('Offer border width is required'),
  collectText: yup.string().required('Free Offer Text is required'),
  arrowColor: yup.string(),
  arrowImage: yup.string(),
  headerImage: yup.string(),
  scrollArrowImage: yup.string(),
  offersBackgroundColor: yup.mixed(),
  offersBackgroundImage: yup.string(),
  offersLockImage: yup.string()
});
